// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.layout-sidebar {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow-x: hidden;
  overflow-y: hidden;
  scroll-behavior: smooth;
  display: flex;
}
.layout-sidebar .sidebar-menu-open {
  margin-left: -250px;
  animation-name: menu-open;
  animation-duration: 0.6s;
  animation-fill-mode: forwards;
}
.layout-sidebar .sidebar-menu-none {
  margin-left: -250px;
}
@keyframes menu-open {
  from {
    margin-left: -250px;
  }
  to {
    margin-left: 0px;
  }
}
.layout-sidebar .sidebar-menu-close {
  margin-left: 0px;
  animation-name: menu-close;
  animation-duration: 0.6s;
  animation-fill-mode: forwards;
}
@keyframes menu-close {
  from {
    margin-left: 0px;
  }
  to {
    margin-left: -250px;
  }
}
.layout-sidebar .sidebar-menu {
  width: 100%;
  max-width: 250px;
  height: 100%;
  box-shadow: 0px 0px 8px 3px rgba(128, 128, 128, 0.342);
  z-index: 2;
  min-width: 250px;
  position: fixed;
  background-color: white;
}
.layout-sidebar .sidebar-menu .logo {
  width: 100%;
  height: 85px;
  box-shadow: 0 8px 4px -6px rgba(121, 121, 121, 0.103);
  display: flex;
  align-items: center;
  justify-content: center;
}
.layout-sidebar .sidebar-menu .logo img {
  width: 200px;
  max-height: 75px;
  object-fit: cover;
}
.layout-sidebar .sidebar-menu .list {
  height: 100%;
  padding: 3px 6px;
  font-size: 1rem;
}
.layout-sidebar .sidebar-menu .list .user {
  height: 45px;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 5px 0px;
  padding: 0px 6px;
  border-radius: 4px;
}
.layout-sidebar .sidebar-menu .list .user .avatar {
  width: 35px;
  height: 35px;
  border-radius: 100%;
  box-shadow: 0px 0px 3px 0.1px grey;
}
.layout-sidebar .sidebar-menu .list .user .avatar img {
  width: 100%;
  border-radius: 100%;
  object-fit: cover;
}
.layout-sidebar .sidebar-menu .list .menu-item,
.layout-sidebar .sidebar-menu .list .menu-title {
  height: 40px;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 5px 0px;
  padding: 0px 12px;
  border-radius: 4px;
  color: black;
  text-decoration: none;
}
@media only screen and (max-width: 792px) {
  .layout-sidebar .sidebar-menu .list .menu-item,
  .layout-sidebar .sidebar-menu .list .menu-title {
    height: 35px;
  }
}
.layout-sidebar .sidebar-menu .list .menu-title {
  height: auto;
  padding: 20px 6px 3px 6px;
}
.layout-sidebar .sidebar-menu .list .hover:hover {
  background-color: rgb(255, 92, 182);
  color: white !important;
  cursor: pointer;
  box-shadow: 0px 0px 3px 0.1px rgba(128, 128, 128, 0.445);
}
.layout-sidebar .sidebar-menu .list .checked {
  background-color: rgb(255, 92, 182);
  color: white !important;
}
.layout-sidebar .sidebar-menu .list .line {
  border-bottom: 0.1px solid rgba(128, 128, 128, 0.185);
}
.layout-sidebar .sidebar-container {
  width: 100%;
  height: 100%;
  margin-left: 250px;
}
.layout-sidebar .sidebar-container .sidebar-container-menu {
  width: 100%;
  height: 45px;
  box-shadow: 0 8px 4px -6px rgba(121, 121, 121, 0.103);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  z-index: 1;
  background-color: white;
}
.layout-sidebar .sidebar-container .sidebar-container-menu .menu {
  display: flex;
  gap: 10px;
  align-items: center;
  padding-left: 20px;
}
.layout-sidebar .sidebar-container .sidebar-container-menu .menu .menu-icon {
  cursor: pointer;
  font-size: 1.5rem;
}
.layout-sidebar .sidebar-container .sidebar-container-menu .login {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-right: 10px;
}
.layout-sidebar .sidebar-container .sidebar-container-menu .login .avatar {
  display: flex;
  align-items: center;
  gap: 5px;
  color: grey;
  cursor: pointer;
}
.layout-sidebar .sidebar-container .sidebar-container-menu .login .avatar img {
  width: 30px;
  height: 30px;
  border-radius: 100%;
  object-fit: cover;
}
.layout-sidebar .sidebar-container .sidebar-container-menu-open {
  left: 250px;
  animation-name: sidebar-menu-open;
  animation-duration: 0.6s;
  animation-fill-mode: forwards;
}
.layout-sidebar .sidebar-container .sidebar-container-menu-none {
  left: 0px;
}
@keyframes sidebar-menu-open {
  from {
    left: 0px;
    width: 100%;
  }
  to {
    left: 250px;
  }
}
.layout-sidebar .sidebar-container .sidebar-container-menu-close {
  left: 250px;
  animation-name: sidebar-menu-close;
  animation-duration: 0.6s;
  animation-fill-mode: forwards;
}
@media only screen and (min-width: 792px) {
  .layout-sidebar .sidebar-container .sidebar-container-menu {
    width: calc(100% - 250px);
  }
}
@keyframes sidebar-menu-close {
  from {
    left: 250px;
  }
  to {
    left: 0px;
    width: 100%;
  }
}
.layout-sidebar .sidebar-container .sidebar-container-content {
  height: calc(100% - 45px);
  padding-top: 45px;
  overflow-y: auto;
  background-color: rgb(255, 253, 161);
  overflow-x: hidden;
}
.layout-sidebar .sidebar-container .sidebar-container-content .sidebar-container-content-top {
  padding: 0px 10px 0px 10px;
  min-height: calc(100% - 76px);
}
.layout-sidebar .sidebar-container .sidebar-container-content::-webkit-scrollbar {
  width: 7px;
}
@media only screen and (max-width: 792px) {
  .layout-sidebar .sidebar-container .sidebar-container-content::-webkit-scrollbar {
    width: 3px;
  }
}
.layout-sidebar .sidebar-container .sidebar-container-content::-webkit-scrollbar-thumb {
  background-color: rgba(128, 128, 128, 0.589);
  border-radius: 3px;
}
.layout-sidebar .sidebar-container .sidebar-container-footer {
  height: 100%;
  max-height: 45px;
  border-top: 0.1px solid rgba(128, 128, 128, 0.185);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px;
  font-size: 0.9rem;
  font-weight: bold;
  color: grey;
  background-color: white;
  margin-top: 30px;
}
@media only screen and (max-width: 792px) {
  .layout-sidebar .sidebar-container .sidebar-container-footer {
    max-height: 100px;
  }
}
.layout-sidebar .sidebar-container-open {
  margin-left: 0px;
  animation-name: container-open;
  animation-duration: 0.6s;
  animation-fill-mode: forwards;
}
.layout-sidebar .sidebar-container-none {
  margin-left: 0px;
}
@keyframes container-open {
  from {
    margin-left: 0px;
  }
  to {
    margin-left: 250px;
  }
}
.layout-sidebar .sidebar-container-close {
  margin-left: 0px;
  animation-name: container-close;
  animation-duration: 0.6s;
  animation-fill-mode: forwards;
}
@keyframes container-close {
  from {
    margin-left: 250px;
  }
  to {
    margin-left: 0px;
  }
}
@media only screen and (max-width: 792px) {
  .layout-sidebar .sidebar-container {
    height: 100vh;
  }
}

.login-avatar-hover-item {
  width: 200px;
  display: flex;
  align-items: center;
  padding: 10px;
  height: 30px;
}

.login-avatar-hover-item:hover {
  background-color: rgb(255, 92, 182);
  color: white;
  border-radius: 4px;
  cursor: pointer;
}

.layout-sidebar-icon-warning {
  color: orange;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0px;
  font-size: 40px;
}

.warning-click-tab-search {
  padding: 0px 10px;
  font-family: "ヒラのノギ";
}
.warning-click-tab-search img {
  width: 100%;
}
.warning-click-tab-search .warning-click-tab-search-title {
  font-weight: 600;
  font-size: 1.2rem;
  text-align: center;
}
.warning-click-tab-search .warning-click-tab-search-content {
  text-align: center;
  font-size: 1rem;
  font-weight: 600;
}
@media only screen and (max-width: 792px) {
  .warning-click-tab-search .warning-click-tab-search-content {
    font-size: 0.8rem;
  }
  .warning-click-tab-search .warning-click-tab-search-title {
    font-size: 1rem;
  }
}

.menu-up-hover:hover {
  box-shadow: 0px 2px 14px #000000;
}

.menu-up-hover:active {
  box-shadow: 0px 2px 6px #000000;
}

.no-hover {
  background-color: white !important;
}

.menu-up {
  font-weight: bold;
  color: red !important;
}`, "",{"version":3,"sources":["webpack://./src/config/LayoutSideBar.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,WAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;AAEJ;AAAI;EACI,mBAAA;EACA,yBAAA;EACA,wBAAA;EACA,6BAAA;AAER;AACI;EACI,mBAAA;AACR;AAEI;EACI;IACI,mBAAA;EAAV;EAGM;IACI,gBAAA;EADV;AACF;AAII;EACI,gBAAA;EACA,0BAAA;EACA,wBAAA;EACA,6BAAA;AAFR;AAKI;EACI;IACI,gBAAA;EAHV;EAMM;IACI,mBAAA;EAJV;AACF;AAQI;EACI,WAAA;EACA,gBAAA;EACA,YAAA;EACA,sDAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;AANR;AAQQ;EACI,WAAA;EACA,YAAA;EACA,qDAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AANZ;AAQY;EACI,YAAA;EACA,gBAAA;EACA,iBAAA;AANhB;AAUQ;EACI,YAAA;EACA,gBAAA;EACA,eAAA;AARZ;AAUY;EACI,YAAA;EAEA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAThB;AAWgB;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kCAAA;AATpB;AAWoB;EACI,WAAA;EACA,mBAAA;EACA,iBAAA;AATxB;AAcY;;EAEI,YAAA;EAEA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;AAbhB;AAegB;EAbJ;;IAcQ,YAAA;EAXlB;AACF;AAcY;EACI,YAAA;EACA,yBAAA;AAZhB;AAeY;EACI,mCAAA;EACA,uBAAA;EACA,eAAA;EACA,wDAAA;AAbhB;AAgBY;EACI,mCAAA;EACA,uBAAA;AAdhB;AAiBY;EACI,qDAAA;AAfhB;AAoBI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAlBR;AAoBQ;EACI,WAAA;EACA,YAAA;EACA,qDAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;EACA,uBAAA;AAlBZ;AAoBY;EACI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;AAlBhB;AAoBgB;EACI,eAAA;EACA,iBAAA;AAlBpB;AAsBY;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AApBhB;AAsBgB;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;AApBpB;AAsBoB;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AApBxB;AA0BQ;EACI,WAAA;EACA,iCAAA;EACA,wBAAA;EACA,6BAAA;AAxBZ;AA2BQ;EACI,SAAA;AAzBZ;AA4BQ;EACI;IACI,SAAA;IACA,WAAA;EA1Bd;EA6BU;IACI,WAAA;EA3Bd;AACF;AA8BQ;EACI,WAAA;EACA,kCAAA;EACA,wBAAA;EACA,6BAAA;AA5BZ;AA+BQ;EACI;IACI,yBAAA;EA7Bd;AACF;AAgCQ;EACI;IACI,WAAA;EA9Bd;EAiCU;IACI,SAAA;IACA,WAAA;EA/Bd;AACF;AAkCQ;EACI,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oCAAA;EAEA,kBAAA;AAjCZ;AAmCY;EACI,0BAAA;EACA,6BAAA;AAjChB;AAqCQ;EACI,UAAA;AAnCZ;AAsCQ;EACI;IACI,UAAA;EApCd;AACF;AAuCQ;EACI,4CAAA;EACA,kBAAA;AArCZ;AAwCQ;EACI,YAAA;EACA,gBAAA;EACA,kDAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;AAtCZ;AAyCQ;EACI;IACI,iBAAA;EAvCd;AACF;AA4CI;EACI,gBAAA;EACA,8BAAA;EACA,wBAAA;EACA,6BAAA;AA1CR;AA6CI;EACI,gBAAA;AA3CR;AA8CI;EACI;IACI,gBAAA;EA5CV;EA+CM;IACI,kBAAA;EA7CV;AACF;AAgDI;EACI,gBAAA;EACA,+BAAA;EACA,wBAAA;EACA,6BAAA;AA9CR;AAiDI;EACI;IACI,kBAAA;EA/CV;EAkDM;IACI,gBAAA;EAhDV;AACF;AAmDI;EACI;IACI,aAAA;EAjDV;AACF;;AAqDA;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;AAlDJ;;AAqDA;EACI,mCAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAlDJ;;AAqDA;EACI,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;AAlDJ;;AAqDA;EACI,iBAAA;EACA,oBAAA;AAlDJ;AAoDI;EACI,WAAA;AAlDR;AAqDI;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;AAnDR;AAsDI;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;AApDR;AAuDI;EACI;IACI,iBAAA;EArDV;EAwDM;IACI,eAAA;EAtDV;AACF;;AA0DA;EACI,gCAAA;AAvDJ;;AA0DA;EACI,+BAAA;AAvDJ;;AA0DA;EACI,kCAAA;AAvDJ;;AA0DA;EACI,iBAAA;EACA,qBAAA;AAvDJ","sourcesContent":[".layout-sidebar {\n    width: 100%;\n    height: 100vh;\n    position: relative;\n    overflow-x: hidden;\n    overflow-y: hidden;\n    scroll-behavior: smooth;\n    display: flex;\n\n    .sidebar-menu-open {\n        margin-left: -250px;\n        animation-name: menu-open;\n        animation-duration: 0.6s;\n        animation-fill-mode: forwards;\n    }\n\n    .sidebar-menu-none {\n        margin-left: -250px;\n    }\n\n    @keyframes menu-open {\n        from {\n            margin-left: -250px;\n        }\n\n        to {\n            margin-left: 0px;\n        }\n    }\n\n    .sidebar-menu-close {\n        margin-left: 0px;\n        animation-name: menu-close;\n        animation-duration: 0.6s;\n        animation-fill-mode: forwards;\n    }\n\n    @keyframes menu-close {\n        from {\n            margin-left: 0px;\n        }\n\n        to {\n            margin-left: -250px;\n        }\n    }\n\n    //\n    .sidebar-menu {\n        width: 100%;\n        max-width: 250px;\n        height: 100%;\n        box-shadow: 0px 0px 8px 3px rgba(128, 128, 128, 0.342);\n        z-index: 2;\n        min-width: 250px;\n        position: fixed;\n        background-color: white;\n\n        .logo {\n            width: 100%;\n            height: 85px;\n            box-shadow: 0 8px 4px -6px rgba(121, 121, 121, 0.103);\n            display: flex;\n            align-items: center;\n            justify-content: center;\n\n            img {\n                width: 200px;\n                max-height: 75px;\n                object-fit: cover;\n            }\n        }\n\n        .list {\n            height: 100%;\n            padding: 3px 6px;\n            font-size: 1rem;\n\n            .user {\n                height: 45px;\n\n                display: flex;\n                align-items: center;\n                gap: 8px;\n                margin: 5px 0px;\n                padding: 0px 6px;\n                border-radius: 4px;\n\n                .avatar {\n                    width: 35px;\n                    height: 35px;\n                    border-radius: 100%;\n                    box-shadow: 0px 0px 3px 0.1px grey;\n\n                    img {\n                        width: 100%;\n                        border-radius: 100%;\n                        object-fit: cover;\n                    }\n                }\n            }\n\n            .menu-item,\n            .menu-title {\n                height: 40px;\n\n                display: flex;\n                align-items: center;\n                gap: 8px;\n                margin: 5px 0px;\n                padding: 0px 12px;\n                border-radius: 4px;\n                color: black;\n                text-decoration: none;\n\n                @media only screen and (max-width: 792px) {\n                    height: 35px;\n                }\n            }\n\n            .menu-title {\n                height: auto;\n                padding: 20px 6px 3px 6px;\n            }\n\n            .hover:hover {\n                background-color: rgb(255, 92, 182);\n                color: white !important;\n                cursor: pointer;\n                box-shadow: 0px 0px 3px 0.1px rgba(128, 128, 128, 0.445);\n            }\n\n            .checked {\n                background-color: rgb(255, 92, 182);\n                color: white !important;\n            }\n\n            .line {\n                border-bottom: 0.1px solid rgba(128, 128, 128, 0.185);\n            }\n        }\n    }\n\n    .sidebar-container {\n        width: 100%;\n        height: 100%;\n        margin-left: 250px;\n\n        .sidebar-container-menu {\n            width: 100%;\n            height: 45px;\n            box-shadow: 0 8px 4px -6px rgba(121, 121, 121, 0.103);\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            position: fixed;\n            z-index: 1;\n            background-color: white;\n\n            .menu {\n                display: flex;\n                gap: 10px;\n                align-items: center;\n                padding-left: 20px;\n\n                .menu-icon {\n                    cursor: pointer;\n                    font-size: 1.5rem;\n                }\n            }\n\n            .login {\n                display: flex;\n                align-items: center;\n                gap: 10px;\n                padding-right: 10px;\n\n                .avatar {\n                    display: flex;\n                    align-items: center;\n                    gap: 5px;\n                    color: grey;\n                    cursor: pointer;\n\n                    img {\n                        width: 30px;\n                        height: 30px;\n                        border-radius: 100%;\n                        object-fit: cover;\n                    }\n                }\n            }\n        }\n\n        .sidebar-container-menu-open {\n            left: 250px;\n            animation-name: sidebar-menu-open;\n            animation-duration: 0.6s;\n            animation-fill-mode: forwards;\n        }\n\n        .sidebar-container-menu-none {\n            left: 0px;\n        }\n\n        @keyframes sidebar-menu-open {\n            from {\n                left: 0px;\n                width: 100%;\n            }\n\n            to {\n                left: 250px;\n            }\n        }\n\n        .sidebar-container-menu-close {\n            left: 250px;\n            animation-name: sidebar-menu-close;\n            animation-duration: 0.6s;\n            animation-fill-mode: forwards;\n        }\n\n        @media only screen and (min-width: 792px) {\n            .sidebar-container-menu {\n                width: calc(100% - 250px);\n            }\n        }\n\n        @keyframes sidebar-menu-close {\n            from {\n                left: 250px;\n            }\n\n            to {\n                left: 0px;\n                width: 100%;\n            }\n        }\n\n        .sidebar-container-content {\n            height: calc(100% - 45px);\n            padding-top: 45px;\n            overflow-y: auto;\n            background-color: rgb(255, 253, 161);\n\n            overflow-x: hidden;\n\n            .sidebar-container-content-top {\n                padding: 0px 10px 0px 10px;\n                min-height: calc(100% - 76px);\n            }\n        }\n\n        .sidebar-container-content::-webkit-scrollbar {\n            width: 7px;\n        }\n\n        @media only screen and (max-width: 792px) {\n            .sidebar-container-content::-webkit-scrollbar {\n                width: 3px;\n            }\n        }\n\n        .sidebar-container-content::-webkit-scrollbar-thumb {\n            background-color: rgba(128, 128, 128, 0.589);\n            border-radius: 3px;\n        }\n\n        .sidebar-container-footer {\n            height: 100%;\n            max-height: 45px;\n            border-top: 0.1px solid rgba(128, 128, 128, 0.185);\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            padding: 0px 10px;\n            font-size: 0.9rem;\n            font-weight: bold;\n            color: grey;\n            background-color: white;\n            margin-top: 30px;\n        }\n\n        @media only screen and (max-width: 792px) {\n            .sidebar-container-footer {\n                max-height: 100px;\n            }\n        }\n    }\n\n    //\n    .sidebar-container-open {\n        margin-left: 0px;\n        animation-name: container-open;\n        animation-duration: 0.6s;\n        animation-fill-mode: forwards;\n    }\n\n    .sidebar-container-none {\n        margin-left: 0px;\n    }\n\n    @keyframes container-open {\n        from {\n            margin-left: 0px;\n        }\n\n        to {\n            margin-left: 250px;\n        }\n    }\n\n    .sidebar-container-close {\n        margin-left: 0px;\n        animation-name: container-close;\n        animation-duration: 0.6s;\n        animation-fill-mode: forwards;\n    }\n\n    @keyframes container-close {\n        from {\n            margin-left: 250px;\n        }\n\n        to {\n            margin-left: 0px;\n        }\n    }\n\n    @media only screen and (max-width: 792px) {\n        .sidebar-container {\n            height: 100vh;\n        }\n    }\n}\n\n.login-avatar-hover-item {\n    width: 200px;\n    display: flex;\n    align-items: center;\n    padding: 10px;\n    height: 30px;\n}\n\n.login-avatar-hover-item:hover {\n    background-color: rgb(255, 92, 182);\n    color: white;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.layout-sidebar-icon-warning {\n    color: orange;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 10px 0px;\n    font-size: 40px;\n}\n\n.warning-click-tab-search {\n    padding: 0px 10px;\n    font-family: 'ヒラのノギ';\n\n    img {\n        width: 100%;\n    }\n\n    .warning-click-tab-search-title {\n        font-weight: 600;\n        font-size: 1.2rem;\n        text-align: center;\n    }\n\n    .warning-click-tab-search-content {\n        text-align: center;\n        font-size: 1rem;\n        font-weight: 600;\n    }\n\n    @media only screen and (max-width: 792px) {\n        .warning-click-tab-search-content {\n            font-size: 0.8rem;\n        }\n\n        .warning-click-tab-search-title {\n            font-size: 1rem;\n        }\n    }\n}\n\n.menu-up-hover:hover {\n    box-shadow: 0px 2px 14px #000000;\n}\n\n.menu-up-hover:active {\n    box-shadow: 0px 2px 6px #000000;\n}\n\n.no-hover {\n    background-color: white !important;\n}\n\n.menu-up {\n    font-weight: bold;\n    color: red !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
